import React, { useEffect, useState } from "react";

const LoyaltySocial = ({subsData, subsUrls}) => {
    
    const networks = ["instagram", "facebook", "telegram", "google", "linkedin"];
    const staticData = {
        "instagram":{ image: "/img/lk/lkLoyalty/inst.svg", name: "Instagram", points: 1200 },
        "facebook":{ image: "/img/lk/lkLoyalty/facebook.svg", name: "Facebook", points: 1500 },
        "telegram":{ image: "/img/lk/lkLoyalty/tg.svg", name: "Telegram", points: 800 },
        "google":{ image: "/img/lk/lkLoyalty/google.svg", name: "Google", points: 1000 },
        "linkedin":{ image: "/img/lk/lkLoyalty/in.svg", name: "In", points: 2000 },
    }

    // const socialNetworks = [
    //     { id: 1, name: "Instagram", points: 1200, imgSrc: "/img/lk/lkLoyalty/inst.svg", subscribe: false },
    //     { id: 2, name: "Facebook", points: 1500, imgSrc: "/img/lk/lkLoyalty/facebook.svg", subscribe: false },
    //     { id: 3, name: "Telega", points: 800, imgSrc: "/img/lk/lkLoyalty/tg.svg", subscribe: true },
    //     { id: 4, name: "Google", points: 1000, imgSrc: "/img/lk/lkLoyalty/google.svg", subscribe: false },
    //     { id: 5, name: "In", points: 2000, imgSrc: "/img/lk/lkLoyalty/in.svg", subscribe: false },
    // ];


    const [hovered, setHovered] = useState(Object.keys(subsUrls).fill(false));

    const handleMouseEnter = (index) => {
        const newHovered = [...hovered];
        newHovered[index] = true;
        setHovered(newHovered);
    };

    const handleMouseLeave = (index) => {
        const newHovered = [...hovered];
        newHovered[index] = false;
        setHovered(newHovered);
    };

    return (
        <div className="min-h-[220px] px-[20px] py-[17px] rounded-[15px] mt-[20px]" 
             style={{ backgroundColor: '#fff' }}>
            <div className="mb-[15px] font-semibold text-[20px]">
                Подписывайтесь на соц сети
            </div>
            <div className="flex items-center justify-center gap-[5px] flex-wrap">
                {Object.keys(subsUrls).map((x, index) => (
                    <div key={index + 1} className="p-[12px] min-w-[120px] flex flex-col justify-center items-center rounded-[15px]"
                         style={{ backgroundColor: '#EFF0F2' }}>
                        <div className="mb-[6px]">
                            <img src={staticData[x].image} alt={staticData[x].name} />
                        </div>
                        <div className="text-[22px]">
                            {staticData[x].points}
                        </div>
                        <div className="text-[14px]">
                            баллов
                        </div>
                        <div className="mt-[10px]">
                            {subsData[x].is_subscribed ? (
                                <div className=" text-[10px] font-bold uppercase rounded-[25px] px-[11px] py-[13px] flex items-center gap-[3px]"
                                style={{
                                    backgroundColor: '#1F2225',
                                    color: '#fff'
                                }}>
                                    <img src="/img/lk/lkLoyalty/galka.svg" />
                                    <div>Выполнено</div>
                                </div>
                            ) : (
                                <button 
                                    className={`text-[10px] uppercase font-bold border-[1px] border-solid rounded-[25px] px-[11px] py-[13px] transition duration-300`}
                                    style={{
                                        color: hovered[index] ? '#fff' :'#C3372E',
                                        borderColor:  '#C3372E',
                                        backgroundColor: hovered[index] ? '#C3372E' :'',
                                    }} 
                                    onClick={() => window.open(subsUrls[x], '_blank').focus()}
                                    onMouseEnter={() => handleMouseEnter(index)}
                                    onMouseLeave={() => handleMouseLeave(index)}
                                >
                                    ПОДПИСАТЬСЯ
                                </button>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default LoyaltySocial;

